export const STRING = "STRING";
export const INTEGER = "INTEGER";
export const NUMBER = "NUMBER";
export const DATE = "DATE";
export const MEMO = "MEMO";
export const COORDINATE = "COORDINATE";
export const GALLERY = "GALLERY";
export const PROGRAM = "PROGRAM";
export const LOOKUP = "LOOKUP";
export const METADATA = "METADATA";
export const FILE = "FILE";
